angular.module('wizard', [
    'ngRoute',
    'ui.router',
    'app',
    'users',
    'companies',
    'resources',
    'ui.checkbox',
    'dashboard'
]);

angular.module('wizard').config(["$routeProvider", "$stateProvider", function ($routeProvider, $stateProvider) {

        $routeProvider
            .when('/wizard',
            {
                templateUrl: "../wizard/wizard.tpl",
                controller: "wizard.WizardInitCtrl",
                controllerAs: "wizard"
            });

        $stateProvider
            .state('wizard',
            {
                url: "/wizard",
                templateUrl: "../wizard/wizard.tpl",
                controller: "wizard.WizardPageCtrl",
                controllerAs: "wizard",
                resolve: {
                    settings: function (wizardService) {
                        return wizardService.getWizardSettings();
                    }
                }
            })
            .state('wizard.companyIntro',
            {
                templateUrl: "../wizard/company-step.tpl?stepName=intro",
                controller: "wizard.WizardCompanyIntroCtrl",
                controllerAs: "wizard"
            })
            .state('wizard.userSettings',
            {
                templateUrl: "../users/user-settings.tpl",
                controller: "users.UserSettingsCtrl",
                controllerAs: "userSettings",
                params: {
                    wizardMode: true
                }
            })
            .state('wizard.companyProfile',
            {
                templateUrl: "../companies/company-form.tpl",
                controller: "companies.EditMyCompanyCtrl",
                controllerAs: "companyAddEdit",
                params: {
                    wizardMode: true
                }
            })
            .state('wizard.phoneVerification',
                {
                    templateUrl: "../wizard/phone-verification.tpl",
                    controller: "wizard.PhoneVerificationCtrl",
                    controllerAs: "phoneVerification",
                    resolve: {
                        settings: function (wizardService) {
                            return wizardService.getWizardSettings();
                        }
                    },
                    params: {

                    }
                })
            .state('wizard.companyFinished', {
                templateUrl: "../wizard/company-step.tpl?stepName=finished",
                controller: "wizard.WizardCompanyFinishedCtrl",
                params: {
                    wizardMode: false
                }
            })
            .state('wizard.complete',
            {
                controller: "wizard.WizardCompleteCtrl",
                controllerAs: "wizard"
            });

    }]
);
